import * as Yup from 'yup';

export const AirlineFormSchema = () =>
  Yup.object({
    code: Yup.string().nullable().required(),
    email: Yup.string().email().nullable().required(),
    phone: Yup.string().nullable().required(),
    name: Yup.string().nullable().required(),
    address: Yup.string().nullable().required(),
    contact: Yup.object({
      id: Yup.string(),
      name: Yup.string().nullable().required(),
      email: Yup.string().email().nullable().required(),
      phone: Yup.string().nullable().required(),
      description: Yup.string().nullable(),
    }).required(),
    preferences: Yup.array().of(Yup.string().required()).nullable().default([]),

    phone_2: Yup.string().nullable().notRequired(),
  });

export type AirlineFormType = Yup.InferType<
  ReturnType<typeof AirlineFormSchema>
>;
